import { ReactChildren, ReactElement } from "react"

export default function Loader({ children }: { children?: ReactChildren | ReactElement | string })
{
    return (
        <span className="loader">
            <i className="fas fa-circle-notch fa-spin"/> { children }
        </span>
    )
}